import { arrayOf, exact, number, shape, string } from 'prop-types';

import { LatLngType } from './point.type';

export const MarkerType = exact({
  category: string,
  id: string.isRequired,
  latlng: LatLngType.isRequired,
  point: shape({ x: number, y: number }),
  region: string,
});

export const MarkersType = arrayOf(MarkerType);
